import type { MyProfileGeo } from "@/lib/types";
import MiniMap from "@/pages/members/components/MiniMap";

function badgeClass(status: number): string {
  if (status === 1 || status === 2) {
    return "bg-primary-100 text-primary-700 border-primary-200";
  }
  if (status === 9) {
    return "bg-accent-100 text-accent-700 border-accent-200";
  }
  return "bg-background-200 text-foreground-600 border-background-300";
}

function statusText(geo: MyProfileGeo, status: number): string {
  if (geo.status_txt) return geo.status_txt;
  if (status === 1 || status === 2) return "지도 위치 확인됨";
  if (status === 9) return "주소를 찾지 못했습니다";
  return "미확인";
}

// 직장주소 좌표 상태 + 미니맵
export default function GeoBlock({ geo }: { geo: MyProfileGeo }) {
  const status = Number(geo.status ?? 0);
  const lat = Number(geo.lat);
  const lon = Number(geo.lon);
  const hasMap = Number.isFinite(lat) && Number.isFinite(lon) && lat > 0 && lon > 0;

  return (
    <section className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
      <h2 className="font-heading text-base font-bold text-foreground-900">지도 확인</h2>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <span
          className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1 text-xs font-semibold ${badgeClass(status)}`}
        >
          <i className="ri-map-pin-line" aria-hidden="true"></i>
          {statusText(geo, status)}
        </span>
        {geo.road_addr && (
          <span className="text-xs text-foreground-500">{geo.road_addr}</span>
        )}
      </div>

      {hasMap && (
        <MiniMap
          lat={lat}
          lon={lon}
          name={geo.road_addr || "내 사업장"}
          className="mt-4 h-[200px] w-full"
        />
      )}

      <p className="mt-3 text-xs leading-relaxed text-foreground-500">
        주소를 바꾸고 저장하면 지도 위치가 자동으로 다시 잡힙니다.
      </p>
    </section>
  );
}